import React, { useMemo } from 'react';
import {
  PT_WEEKDAY_MIN,
  addMonths,
  formatMonthLabel,
  isSameDay,
  isSameMonth,
  monthGridDays,
  toDateKey,
} from './cccCalTypes';

type MiniMonthProps = {
  monthDate: Date;
  selectedDate: Date;
  today: Date;
  eventDays: Set<string>;
  onChangeMonth: (date: Date) => void;
  onSelectDate: (date: Date) => void;
};

const MiniMonth: React.FC<MiniMonthProps> = ({
  monthDate,
  selectedDate,
  today,
  eventDays,
  onChangeMonth,
  onSelectDate,
}) => {
  const days = useMemo(() => monthGridDays(monthDate), [monthDate]);

  return (
    <div className="grh-mini-month">
      <div className="grh-mini-month-head">
        <span className="grh-mini-month-title">{formatMonthLabel(monthDate)}</span>
        <div className="grh-mini-month-nav">
          <button
            type="button"
            onClick={() => onChangeMonth(addMonths(monthDate, -1))}
            aria-label="Mês anterior"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={() => onChangeMonth(addMonths(monthDate, 1))}
            aria-label="Mês seguinte"
          >
            ›
          </button>
        </div>
      </div>

      <div className="grh-mini-month-weekdays">
        {PT_WEEKDAY_MIN.map((w, i) => (
          <span key={`${w}-${i}`}>{w}</span>
        ))}
      </div>

      <div className="grh-mini-month-grid">
        {days.map((d) => {
          const key = toDateKey(d);
          const isOtherMonth = !isSameMonth(d, monthDate);
          const isSelected = isSameDay(d, selectedDate);
          const isToday = isSameDay(d, today);
          const hasEvents = eventDays.has(key);
          return (
            <button
              key={key}
              type="button"
              className={[
                'grh-mini-day',
                isOtherMonth ? 'is-other' : '',
                isSelected ? 'is-selected' : '',
                isToday ? 'is-today' : '',
                hasEvents ? 'has-events' : '',
              ].filter(Boolean).join(' ')}
              onClick={() => onSelectDate(d)}
              aria-label={d.toDateString()}
              aria-current={isToday ? 'date' : undefined}
              aria-pressed={isSelected}
            >
              <span className="grh-mini-day-num">{d.getDate()}</span>
              <span className="grh-mini-day-dot" aria-hidden="true" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MiniMonth;
